import { RESET_EDIT_ADDRESS } from '../types'
export const reseteditaddress = () => {

    return (dispatch) => {
        dispatch({ type: RESET_EDIT_ADDRESS });
    }
}